<template>
  <TextField
    id="mealplan-api-url"
    :name="`${formNamespace}keystore.API_URL`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.apiUrl')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.apiUrlPlaceholder')"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
